import React from 'react';
import { Grid, CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';

import Hotspot from './Hotspot/Hotspot';

export const Hotspots = () => {
    const { hotspots, isLoading } = useSelector((state) => state.hotspots);

    if (!hotspots.length && !isLoading) {
        return (
            <div className="atlas-empty-state">
                No published hotspot cells are available right now. Use the live hotspots panel
                above for current regional signals while the legacy archive is empty.
            </div>
        );
    }

    return (
        isLoading ? (
            <div className="atlas-loading-state">
                <CircularProgress />
            </div>
        ) : (
            <Grid container alignItems="stretch" spacing={3}>
                {hotspots.map((item) => (
                    <Grid key={item._id || item.item_type_id || item.id || item.h3_location || item.taxonKey} item xs={12} sm={6}>
                        <Hotspot hotspotInfo={item} />
                    </Grid>
                ))}
            </Grid>
        )
    )
}
